import { Col, Form, Row, Select } from "antd";
import type React from "react";

const { Option } = Select;

interface MemberRegistrationStatusFilterProps {
	className?: string;
}

export const MemberRegistrationStatusFilter: React.FC<
	MemberRegistrationStatusFilterProps
> = ({ className = "mb-4" }) => {
	return (
		<Row gutter={[16, 16]} justify="start">
			<Col xs={{ span: 24 }}>
				<Form.Item name="isRegistered" className={className}>
					<Select placeholder="会員登録あり／会員登録なし" allowClear>
						<Option value={true}>会員登録あり</Option>
						<Option value={false}>会員登録なし</Option>
					</Select>
				</Form.Item>
			</Col>
		</Row>
	);
};
